import React from "react";
import HomepagePicture from "./homepagePicture";
import Lottie from "lottie-react";
import animation from "../homepage/data.json";
import ScrollAnimated from "components/ScrollAnimated";
import AppleStoreButton from "components/applestorebutton";

type State = {};

export class Homepage extends React.Component<{}, State> {
  async componentDidMount() {}

  render() {
    return (
      <div className="Homepage_root">
        <div className="max-h-screen relative pt-24 mb-60 flex items-center flex-col overflow-y-clip">
          <div className="z-10 h-[227px] flex flex-col justify-center items-center text-center">
            <h1 className=" font-gaegu-regular text-large md:text-extralarge h-[56px]">
              <span>Sono</span> <span className=" opacity-50">&amp;</span>{" "}
              <span>Su</span>{" "}
            </h1>
            <h1 className=" font-gaegu-regular md:text-gigantic h-[84px] font-bold">
              <span className=" tracking-[4pt]">Fishing for Treasure</span>
            </h1>
          </div>
          <div className="relative">
            <ScrollAnimated
              className=" absolute top-[0px] z-10 storybookforkids w-full h-full max-h-[20%]"
              movementSpeed={10}
              start={0}
              goal={-30}
            />
            <Lottie
              className=" max-w-[1600px] mt-[-10px]"
              animationData={animation}
              loop={true}
            />
          </div>
        </div>
        <div className=" absolute confetti opacity-[0.04] w-full h-full max-w-[3292px] max-h-[2066px]"></div>

        <div
          className="relative flex w-full flex-col xl:flex-row justify-between max-w-[1647px] 
        ml-auto mr-auto mb-[200px] xl:mb-[300px] lg:pl-20 lg:pr-20"
        >
          <div className="flex flex-col text-center items-center xl:items-start xl:text-left">
            <h1 className=" font-bold mb-7 heart-red">App</h1>
            <p className=" font-bold mb-8">
              Follow Sono and Su on their charming adventure in this <br />{" "}
              animated storybook for kids.
            </p>
            <ul className="mb-8">
              <li className="bulletpoint-orange">A charming story</li>
              <li className="bulletpoint-red">Fun and cute animations</li>
              <li className="bulletpoint-pink">Delightfully hand-drawn</li>
            </ul>
            <label className="mb-8">
              No third-party advertising
              <br />
              No in-app purchases
            </label>
            <div className="h-[60px] flex flex-col items-center xl:items-start mb-20">
              <AppleStoreButton />
            </div>
          </div>
          <div className="flex flex-col xl:flex-1 h-[200px] xxxs:h-[400px] sm:h-[500px] md:h-[624.02px] w-full items-center xl:max-w-[800px] mt-14 xl:mt-0 drop-shadow-lg">
            <HomepagePicture
              clippingShapeClass="homepage-clip-1 h-[818px] bottom-0"
              featureImageString="/images/Bubble - Top Hat/Sono Top Hat TEMPORARY.png"
              backgroundSrc="/images/Bubble - Top Hat/Top Hat Background.png"
              characterMask="homepage-clip-1-clipping h-[818px] bottom-0"
              characterClasses="bg-center h-[425px] xxxs:h-[425px] xxs:h-[582px] sm:h-[682px] md:h-[780px] lg:h-[780px] max-w-[976px]"
              characterAnimSettings={{
                movementSpeed: 75,
                start: 10,
                target: -2,
              }}
              backgroundAnimSettings={{
                movementSpeed: 2,
                start: 0,
                target: 150,
              }}
            />
          </div>
        </div>
        <div
          className="flex w-full flex-col xl:flex-row-reverse 
        justify-between max-w-[1647px] ml-auto mr-auto lg:pl-20 lg:pr-20"
        >
          <div className="flex flex-col pl-5 text-center items-center xl:items-start xl:text-left">
            <h1 className=" font-bold mb-7 heart-blue">Languages</h1>
            <p className=" font-bold mb-8">
              Available in the following languages
            </p>
            <div className="max-h-[284px] flex justify-center">
              <div className="w-full mb-8 flex max-w-[550px] justify-between align-top flex-wrap gap-x-12 gap-y-1 pr-5 pb-5">
                <ul className=" flex flex-col text-start">
                  <li className="bulletpoint-orange">English</li>
                  <li className="bulletpoint-red">Bahasa</li>
                  <li className="bulletpoint-pink">Deutsch</li>
                  <li className="bulletpoint-blue">Español</li>
                  <li className="bulletpoint-green">Nederlands</li>
                  <li className="bulletpoint-orange">Português</li>
                  <li className="bulletpoint-red">Svenska</li>
                </ul>
                <ul className=" flex flex-col text-start ">
                  <li className="bulletpoint-pink">简体中文</li>
                  <li className="bulletpoint-blue">にほんご</li>
                  <li className="bulletpoint-green">한국인</li>
                </ul>
                <ul className=" flex flex-col text-start ">
                  <li className="bulletpoint-orange">Русский</li>
                  <li className="bulletpoint-red">Български</li>
                </ul>
              </div>
            </div>
            <div className="h-[60px] flex flex-col items-center xl:items-start mb-20">
              <AppleStoreButton />
            </div>
          </div>
          <div className="flex flex-col xl:flex-1 h-[200px] xxxs:h-[400px] sm:h-[500px] md:h-[624.02px] w-full items-center xl:max-w-[800px] mt-14 xl:mt-0 drop-shadow-lg">
            <HomepagePicture
              clippingShapeClass="homepage-clip-2 h-[818px] bottom-0"
              featureImageString="/images/Bubble - Space/Su Space TEMPORARY.png"
              backgroundSrc="/images/Bubble - Space/Space Background.png"
              characterMask="homepage-clip-2-clipping h-[818px] bottom-0"
              characterClasses="bg-left h-[320px] xxxs:h-[220px] xxs:h-[582px] sm:h-[682px] md:h-[730px] lg:h-[700px] max-w-[976px]"
              characterAnimSettings={{
                movementSpeed: 200,
                start: 30,
                target: -2,
              }}
              backgroundAnimSettings={{
                movementSpeed: 2,
                start: 10,
                target: 0,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
